<template>
  <div class="relative pt-4">
    <!-- <PopupWhoWeAre
      :isActive="isDetailsActive"
      :selectedWhoWeAre="selectedWhoWeAre"
      @close="toggleDetails"
    /> -->

    <div class="absolute bg-design6 mob-hidden">
      <img
        src="../../../assets/images/bg-des/bgd6.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="absolute bg-design7">
      <img
        src="../../../assets/images/Ellipse 12.svg"
        alt="bg-polygon"
        class="h-full"
      />
    </div>
    <div class="lg:py-12 md:py-12 w-full mx-auto lg:mt-8 md:mt-8 mt-4">
      <p class="title md:font-normal lg:font-normal font-bold sm-fsize16">
        Our Services
      </p>
      <p class="subtitle pt-2 lh32px sm-lh26 sm-fsize13">
        To request for a service, fill the form below
      </p>
      <div class="lg:mt-10 md:mt-10 mt-6 bg-white">
        <div
          class="lg:grid md:grid lg:grid-cols-3 md:grid-cols-2 lg:gap-8 md:gap-8"
        >
          <!-- <div
            class="relative rounded-xl lg:mb-0 md:mb-0 mb-4 cursor-pointer shadow-lg bg-white"
            @click="toggleDetails(true, item)"
            v-for="(item, index) in cards"
            :key="index"
          >
            <div class="">
              <div class="w-full py-4">
                <img :src="item.img" :alt="item.title" class="offerImg" />
              </div>
              <div class="w-full lg:px-8 text-center">
                <p
                  class="lg:text-xl md:text-xl sm-fsize14 text-black font-semibold pb-2 cursor-pointer"
                >
                  {{ item.title }}
                </p>
              </div>
            </div>
          </div> -->
          <div
            class="flip-card relative rounded-xl lg:mb-0 md:mb-0 mb-4 shadow-lg"
            v-for="item in cards"
            :key="item._id"
          >
            <div class="flip-card-inner">
              <div class="flip-card-front rounded-t-lg">
                <div class="w-full">
                  <img
                    :src="
                      item.icon
                        ? `${$imageURL}/${item.icon}`
                        : require(`@/assets/images/AuthorImage.jpg`)
                    "
                    :alt="item.title"
                    class="offerImg"
                  />
                </div>
                <div class="w-full text-center">
                  <p
                    class="lg:text-xl md:text-lg sm-fsize14 text-black font-semibold py-2"
                  >
                    {{ item.title }}
                  </p>
                </div>
              </div>
              <div
                class="flip-card-back flex flex-col text-center justify-between"
              >
                <div class="text-left p-4">
                  <h2
                    class="lg:text-xl md:text-lg sm-fsize14 text-black font-semibold py-2"
                  >
                    {{ item.title }}
                  </h2>
                  <div v-html="item.description" class="ellipsis-8"></div>
                  <!-- <button
                    type="button"
                    class="font-semibold font-primary custoutline cursor-pointer"
                    @click="handleRedirect(item)"
                  >
                    Read More
                  </button> -->
                </div>
                <div
                  class="w-full lg:px-8 text-center mb-3"
                  v-if="user.role !== 'vendor' && user.role !== 'volunteer'"
                >
                  <b-button variant="primary" @click="handleRedirect(item)">
                    <!-- {{ user }} -->
                    Read More
                  </b-button>
                  <!-- <b-button variant="primary" @click="handleBookService(item)">
                    Book Service
                  </b-button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="border my-4 rounded-lg p-3 lg:mb-12 md:mb-12">
      <h3 class="fsize22 font-semibold">Disclaimer:</h3>
      <p class="leading-tight fsize16 mt-3 clr-2e2e2e">
        Please note that the products and services available on Caregiver
        Saathi's shop may involve direct payments or affiliate partnerships. For
        items requiring payment, terms and conditions, including payment
        methods, cancellations, and refunds, are governed by the respective
        product manufacturer or service provider.
      </p>
      <p class="fsize16 mt-1 clr-2e2e2e">
        The minimum delivery time is one week, while the maximum delivery time
        is four weeks.
      </p>
      <p class="fsize16 leading-tight mt-2 clr-2e2e2e">
        All the paid services and products are being managed and provided by
        Karuna Tech Services Private Limited(KTSPL).
      </p>
      <p class="fsize16 mt-2 clr-2e2e2e">
        For any queries or assistance regarding your purchase, please contact us
        at:
      </p>
      <p class="fsize16 font-medium clr-2e2e2e">
        Phone: <a href="tel:9619962168">9619962168</a>
      </p>
      <p class="fsize16 font-medium clr-2e2e2e">
        Email:
        <a href="mailto:services@caregiversaathi.co.in"
          >services@caregiversaathi.co.in</a
        >
      </p>
      <div class="fsize16 leading-tight mt-2 clr-2e2e2e">
        <p class="font-semibold">Refund Policy :</p>
        <p>
          For products and services provided by third-party vendors, refunds
          will be processed and credited to your bank directly by the respective
          service provider or product manufacturer. Upon verification of your
          claim, the refund will be issued within 5-14 business days.
        </p>
        <p>
          For products and services offered directly by Caregiver Saathi (CGS)
          or our empaneled partners, refunds will be processed and credited to
          your bank within the timeframe of 5-8 business days after claim
          verification.
        </p>
      </div>
      <p class="fsize16 font-medium mt-2 clr-2e2e2e">
        <span class="font-semibold">Operational Address:</span>
        <br />
        HD-093, WeWork Oberoi Commerz II, 1st Floor CTS No 95, 4B 3 and 4 590,
        W.E Highway, Oberoi Garden City, Goregaon (E), MUMBAI SUBURBAN,
        District: Mumbai, State: Maharashtra - 400063
      </p>
      <p class="fsize16 font-medium clr-2e2e2e">
        (c) Telephone number of the person/association(with STD Code):
        09833312168
      </p>
      <p class="fsize16 leading-tight mt-2 clr-2e2e2e">
        We are committed to providing you with the best shopping experience and
        will address any concerns promptly. Thank you for shopping with us!
      </p>
    </div>
    <b-modal
      id="modal-1"
      return-focus="#shopRegisterService"
      :title="title"
      class="relative"
      hide-footer
    >
      <!-- <p class="lg:text-xl md:text-xl sm-fsize14 text-black font-semibold">
        {{ title }}
      </p> -->
      <p class="" v-html="description"></p>
      <div class="w-full text-center mt-2">
        <b-button variant="primary" @click="handleRedirect(selectedCard)">
          Book Service
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import jwt from "jsonwebtoken";
// import PopupWhoWeAre from "./PopupWhoWeAre.vue";
export default {
  components: {
    // PopupWhoWeAre,
  },
  data() {
    return {
      description: "",
      selectedCard: {},
      title: "",
      selectedWhoWeAre: {},
      isDetailsActive: false,
      cards: [],
      userDetails: {},
    };
  },
  computed: {
    ...mapState("services", { get_AllService: "get_AllService" }),
    ...mapState("auth", ["user"]),
  },
  methods: {
    isShowDesc(desc, title, selectedCard) {
      // this.$bvModal.show("modal-1");
      // this.description = desc;
      // this.selectedCard = selectedCard;
      // this.title = title;
    },
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedWhoWeAre = item;
    },
    handleClick(name) {
      this.$router.push({ name: name });
      // this.toggleNavbar();
    },
    closeModal(id) {
      this.$bvModal.hide(id);
      // this.$root.$emit("bv::hide::modal", id, "#shopRegisterService");
    },
    delay(delayInms) {
      return new Promise((resolve) => setTimeout(resolve, delayInms));
    },
    async handleRedirect(item) {
      this.$store.commit("services/SELECTED_SERVICE_CARD", item);
      if (this.userDetails === null) {
        // this.$router.push({ name: "signin" });
        // return;
        // this.$swal
        //   .fire({
        //     title: "Login!",
        //     text: "Please login to continue",
        //     icon: "info",
        //     confirmButtonText: "Okay",
        //     confirmButtonColor: "#830c81",
        //     showCancelButton: false,
        //   })
        //   .then((result) => {
        //     if (result.isConfirmed) {
        //       this.$router.push({ name: "signin" });
        //       return;
        //     }
        //   });
        // return;
      }
      // await this.delay(300);
      if (item.isURL) {
        window.open(`${item.link}?service=${item.title}`, "_blank");
      } else if (item.isScrollSF) {
        this.closeModal("modal-1");
        const el = document.getElementById("shopRegisterService");
        // console.log(el);

        // el.focus();
        if (el == null || el == "null") {
          // this.$router.push(`service-overview?service=${item.title}`);
          window.open(
            `${window.location.origin}/service-overview?service=${item.title}`,
            "_blank"
          );
        } else {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      } else {
        window.open(
          `${window.location.origin}/service-overview?service=${item.title}`,
          "_blank"
        );
      }
    },
    async handleBookService() {
      let urlToRedirect = `${window.location.origin}${window.location.pathname}`;
      localStorage.setItem("bookService", true);
      window.open(urlToRedirect, "_self");
      const getForm = document.getElementById("serviceForm");

      // getForm.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    async getallServices() {
      try {
        const getServices = await this.$store.dispatch("services/get_all");
        // console.log(getServices);
        this.cards = this.get_AllService.result;
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    // this.userDetails = jwt.decode(localStorage.getItem("token"));
    this.userDetails = sessionStorage.getItem("token");
    await this.getallServices();
    if (localStorage.getItem("bookService")) {
      const getForm = document.getElementById("serviceForm");
      getForm.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    localStorage.removeItem("bookService");
  },
};
</script>
<style>
.offerImg {
  width: 100%;
  height: 330px;
  margin: auto;
  object-fit: cover;
}

.flip-card {
  background-color: transparent;
  width: 100%;
  height: 380px;
  perspective: 1000px;
}

.flip-card-inner {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}

.flip-card:hover .flip-card-inner {
  transform: rotateY(180deg);
}

.flip-card-front,
.flip-card-back {
  position: absolute;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.flip-card-front {
  color: black;
}

.flip-card-back {
  background-color: #eee2ff;
  color: black;
  transform: rotateY(180deg);
}

.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 0.5rem 1.5rem !important;
}
.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
.custoutline {
  outline: none !important;
}
</style>
